module.exports = __webpack_public_path__ + "media/images/faustobotelho-6e45b13b8e3351a2e770b32a14391e81.png";